<template>
  <UpdateAvailability
    :show-availability-dialog="availabilityDialog"
    @hideModal="hideModal"
  >
    <template slot="updateAvailabiltyButton">
      <v-row
        no-gutters
        class="mb-4"
      >
        <v-col>
          <v-btn
            rounded
            :color="color"
            dark
            @click="handleUpdateAvailabilityClick"
          >
            <span>{{ title }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </UpdateAvailability>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import UpdateAvailability from '@/components/core/UpdateAvailability.vue'

@Component({
  components: {
    UpdateAvailability
  }
})
export default class WeeklyAvailability extends Vue {
  @Prop({ default: 'Edit my availability' }) title: string
  @Prop({ default: 'secondary' }) color: string

  // data
  availabilityDialog: boolean = false

  // methods
  handleUpdateAvailabilityClick () {
    this.availabilityDialog = true
  }

  hideModal () {
    this.availabilityDialog = false
  }
}
</script>
